import { useFormik } from "formik";
import { FC, useContext, useEffect, useState } from "react";
import NoDataMsg from "../../../../common/components/NoDataMsg";
import SearchableSelect from "../../../../common/components/SearchableSelect";
import AuthContext from "../../../../contexts/authContext";
import useDarkMode from "../../../../hooks/useDarkMode";
import Page from "../../../../layout/Page/Page";
import PageWrapper from "../../../../layout/PageWrapper/PageWrapper";
import SubHeader, { SubHeaderLeft, SubheaderSeparator, SubHeaderRight } from "../../../../layout/SubHeader/SubHeader";
import AlertService from "../../../../services/AlertService";
import { getLicenseKey } from "../../../../services/application.settings";
import { getCurrentDateAndTime, profilePic, pictNotLoading, onlyAllowNumber } from "../../../../services/common.service";
import { getStudentFeeDetails, getStudentTotalFeeCollection, getNotAssignedSemesterFees, addStudentFineFee, addStudentFeeCollection, addFineFeeType, addStudentAdvanceFee, getFeeType, getFineFeeType, getExtraFeeType, getStudentFineFeeList, addExtraFeeDetails, addOrUpdStudentFeeDetails, getStudentFeeDetailsHistory, getStudentBulkFeesDetails, addStudentBulkFeeCollection } from "../../../../services/fee.service";
import { showLoader, TableLoader } from "../../../../services/loader.services";
import { getProfileForStudent } from "../../../../services/student.service";
import { toasts } from "../../../../services/toast.service";
import Alert from "../../../bootstrap/Alert";
import Button from "../../../bootstrap/Button";
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardTitle } from "../../../bootstrap/Card";
import Modal, { ModalHeader, ModalTitle, ModalBody } from "../../../bootstrap/Modal";
import OffCanvas, { OffCanvasHeader, OffCanvasTitle, OffCanvasBody } from "../../../bootstrap/OffCanvas";
import Checks, { ChecksGroup } from "../../../bootstrap/forms/Checks";
import FormGroup from "../../../bootstrap/forms/FormGroup";
import Textarea from "../../../bootstrap/forms/Textarea";
import Icon from "../../../icon/Icon";
import Input from "../../../bootstrap/forms/Input";
import Label from "../../../bootstrap/forms/Label";
import useSortableData from "../../../../hooks/useSortableData";
import { dataPagination } from "../../../PaginationButtons";


interface IStudentDetailsIdProps {
    departmentId: any;
    courseId: any;
    batchMasterId: any;
    semesterDetailsId: any;
    sectionDetailsId: any;
    feeTypeId: any;
    graduationTypeId: any;
    setShowPayFees(...args: unknown[]): unknown;
    refreshAfterFeeCollection(...args: unknown[]): unknown;
    showPayFees: any;
}

const PayBulkFees: FC<IStudentDetailsIdProps> = ({ departmentId, courseId, batchMasterId, semesterDetailsId, graduationTypeId, sectionDetailsId, feeTypeId, setShowPayFees, showPayFees, refreshAfterFeeCollection }) => {


    console.log(feeTypeId);

    useEffect(() => {
        getStudentBulkFeesDetailsList(courseId?.value, batchMasterId?.value, semesterDetailsId?.value, sectionDetailsId?.value, feeTypeId?.value)
    }, []);

    const { userAccountId, userTypeId } = useContext(AuthContext);

    const [feesCollectionDetailsArray, setFeesCollectionDetailsArray] = useState<any>([])
    const [isLoader, setIsLoader] = useState(false)

    const [studentFeeCollectionData, setStudentFeeCollectionData] = useState<any>([])
    const [nodataForPaidBills, setNodataForPaidBills] = useState('')
    const [columnVisibilityDataForFeeCollection, setColumnVisibilityDataForFeeCollection] = useState([]);
    const [allColumnsData, setAllColumnsData] = useState([]);

    // For Table
    const [studentDetailsData, setStudentDetailsData] = useState<any>([])
    const [dataSuccess, setDataSuccess] = useState(false)
    const [isOpenListCard, setIsOpenListCard] = useState(true)
    const { themeStatus, darkModeStatus } = useDarkMode();
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [receiptOpenModal, setReceiptOpenModal] = useState(false)
    const [payFeesOpenCard, setPayFeesOpenCard] = useState(false)


    const [studentFeeReceiptData, setStudentFeeReceiptData] = useState<any>([])
    const [collegeDetailsData, setCollegeDetailsData] = useState<any>([])
    const tableFontSize = 'fs-4';

    const [paymentTypeId, setPaymentTypeId] = useState(1)
    const [fivehunderd_total, setFivehunderd_total] = useState<any>("")
    const [twoHundred_total, setTwoHundred_total] = useState<any>("")
    const [hundred_total, setHundred_total] = useState<any>("")
    const [fifty_total, setFifty_total] = useState<any>("")
    const [twenty_total, setTwenty_total] = useState<any>("")
    const [ten_total, setTen_total] = useState<any>("")
    const [five_total, setFive_total] = useState<any>("")
    const [totalAmount, setTotalAmount] = useState<any>("")
    const [balCashAmount, setBalCashAmount] = useState<any>("")
    const [totalFeesAmount, setTotalFeesAmount] = useState<any>(0)
    const [totalBalFeesAmount, setTotalBalFeesAmount] = useState<any>(0)
    const [totalReceivedFeesAmount, setTotalReceivedFeesAmount] = useState<any>(0)
    const [totalFeesCollectionAmount, setTotalFeesCollectionAmount] = useState<any>(0)
    const [courseFeeMasterId, setCourseFeeMasterId] = useState<any>(0)
    const [filteredDataToRefresh, setFilteredDataToRefresh] = useState<any>([])

    // For Alert
    const [alertStatus, setAlertStatus] = useState<any>({ message: "", type: "" });
    const [isOpen, setIsOpen] = useState(false);

    const [noDataMsg, setNoDataMsg] = useState('')
    const [isCheckAll, setIsCheckAll] = useState(false);
    const [checkSelectAll, setCheckSelectAll] = useState(false);

    const TABS = {
        CASH_PAYMENTS: 'Cash',
        CHEQUE: 'Cheque',
        NEFT_UPI: 'NEFT / UPI',
        CARD_PAYMENT: 'Card',
    };

    const [activeTab, setActiveTab] = useState(TABS.CASH_PAYMENTS);

    const { items, requestSort, getClassNamesFor } = useSortableData(studentDetailsData);
    const onCurrentPageData = dataPagination(items, currentPage, perPage);

    const columnVisibilityForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            searchInput: '',
            available: false,
        },
        validate: (values) => { },
        //validateOnChange: false,
        onSubmit: () => { },
    });

    const payFeesDenominationForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            receiptDate: getCurrentDateAndTime('date'),
            paymentTypeId: '',
            twoThousand_total: '',
            twoThousand_count: '',
            thousand_total: '',
            thousand_count: '',
            fivehunderd_total: '',
            fivehunderd_count: '',
            twoHundred_total: '',
            twoHundred_count: '',
            hundred_total: '',
            hundred_count: '',
            fifty_total: '',
            fifty_count: '',
            twenty_total: '',
            twenty_count: '',
            ten_total: '',
            ten_count: '',
            five_total: '',
            five_count: '',
            totalAmount: '',
            chequeNumber: '',
            chequeDate: getCurrentDateAndTime('date'),
            chequeAmount: '',
            chequeBankName: '',
            neftRefNumber: '',
            neftTranDate: getCurrentDateAndTime('date'),
            neftAmount: '',
            neftBankName: '',
            cardNumber: '',
            cardDate: getCurrentDateAndTime('date'),
            cardAmount: '',
            cardBankName: '',
            balCashAmount: '',
            narration: ''
        },
        // validate: (values) => {
        //     const errors: {
        //         examMonthName?: string;
        //     } = {};
        //     if (!values.examMonthName) {
        //         errors.examMonthName = 'Required';
        //     }
        //     return errors;
        // },
        //validateOnChange: false,
        onSubmit: () => { },
    });

    // Filter
    const filteredData = items.filter(
        (i) =>
            i.admissionNo.toLowerCase().includes(columnVisibilityForm.values.searchInput.toLowerCase()) ||
            i.studentName.toLowerCase().includes(columnVisibilityForm.values.searchInput.toLowerCase())
    );


    function getStudentBulkFeesDetailsList(courseId: number, batchMasterId: number, semesterDetailsId: number, sectionDetailsId: number, feeTypeId: number) {
        getStudentBulkFeesDetails(courseId, batchMasterId, semesterDetailsId, sectionDetailsId, feeTypeId,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.studentBulkFeesDetails;
                    if (data != undefined) {

                        for (let i = 0; i < data.length; i++) {
                            data[i].sno = i + 1;
                            data[i].amount = data[i].balanceToBePaid;
                            data[i].isEditable = data[i].isEditable = true;
                            data[i].isSelect = data[i].isSelect = false;
                        }

                        let checkSelectAll = data.filter((item: any) => item.balanceToBePaid > 0)

                        setCourseFeeMasterId(data[0].courseFeeMasterId)

                        setCheckSelectAll(checkSelectAll.length > 0 ? true : false)

                        setTotalFeesAmount(data.reduce((sum: any, student: any) => sum + student.totalFees, 0))
                        setTotalBalFeesAmount(data.reduce((sum: any, student: any) => sum + student.balanceToBePaid, 0))
                        setTotalReceivedFeesAmount(data.reduce((sum: any, student: any) => sum + student.feeReceived, 0))
                        setIsCheckAll(false)
                        setIsLoader(false);
                        setStudentDetailsData(data);
                        setIsOpenListCard(false);
                        setFilteredDataToRefresh(data)
                        setDataSuccess(true);
                        setPayFeesOpenCard(true);
                    } else {
                        setIsLoader(false);
                        setDataSuccess(false);
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setIsLoader(false);
                    setDataSuccess(true);
                    setIsOpenListCard(false);
                    setStudentDetailsData([]);
                    setNoDataMsg(response.data.message)
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    setIsLoader(false);
                    toasts(errorDescription, "Error")
                }
            }, error => {
                setIsLoader(false);
                toasts(error, "Error")
            }
        )
    }

    const selectAllStudents = (e: any) => {
        const newData: any = [];
        const newData1: any = [];
        setIsCheckAll(e)
        if (e == true) {

            filteredDataToRefresh.forEach((item: any, index: any) => {
                if (item['studentFeeDetailsId'] == item.studentFeeDetailsId) {
                    item['isSelect'] = true;
                    item['isEditable'] = false;
                }
                newData1.push(item);
                if (item.balanceToBePaid > 0) {
                    const objForConfirmation = {
                        studentFeeDetailsId: item.studentFeeDetailsId,
                        amount: item.amount,
                    };
                    feesCollectionDetailsArray.push(objForConfirmation);
                    totalPayFees()
                }

            });
            setFilteredDataToRefresh(newData1);

        } else {
            filteredDataToRefresh.forEach((item: any) => {
                item.isSelect = false
                item.isEditable = true
                setFeesCollectionDetailsArray([])
                setTotalFeesCollectionAmount(0)
            });
        }

        console.log(feesCollectionDetailsArray);
    }

    const updateStaffDetailsIdValue = (e: any, cell: number, amount: any) => {

        const newData: any = [];

        if (e == true) {
            filteredDataToRefresh.forEach((item: any, index: any) => {
                if (item['studentFeeDetailsId'] == cell) {
                    item['isSelect'] = true;
                    item['isEditable'] = false;
                }
                newData.push(item);
            });
            setFilteredDataToRefresh(newData);
        }
        else if (e == false) {
            setIsCheckAll(false)
            filteredDataToRefresh.forEach((item: any, index: any) => {
                if (item['studentFeeDetailsId'] == cell) {
                    item['isSelect'] = false;
                    item['isEditable'] = true;
                }
                newData.push(item);
            });
            setFilteredDataToRefresh(newData);
        }

        if (feesCollectionDetailsArray.length == 0) {
            const obj = {
                studentFeeDetailsId: cell,
                amount: amount
            };
            feesCollectionDetailsArray.push(obj);
        } else {
            let selectedItem1: any;
            feesCollectionDetailsArray.forEach((item: any, index: any) => {
                if (item['studentFeeDetailsId'] == cell) {
                    selectedItem1 = item;
                    selectedItem1['studentFeeDetailsId'] = cell;
                    selectedItem1['amount'] = amount;
                }
            });
            if (selectedItem1 != undefined) {
                feesCollectionDetailsArray.splice(
                    feesCollectionDetailsArray.indexOf(selectedItem1),
                    1,
                );
                selectedItem1['studentFeeDetailsId'] = cell;
            }
            else if (selectedItem1 != undefined) {
                selectedItem1['studentFeeDetailsId'] = cell
            }
            else {
                var obj;
                obj = {
                    studentFeeDetailsId: cell,
                    amount: amount
                };

                feesCollectionDetailsArray.push(obj);
            }
        }
        totalPayFees()
        console.log(feesCollectionDetailsArray);

    };

    const updateFeesReceivedValue = (cell: number, amount: any) => {

        studentDetailsData.forEach((item: any) => {
            const newData: any = [];

            if (item.studentFeeDetailsId == cell) {
                item.amount = amount
            }
            newData.push(item)
            setFilteredDataToRefresh(newData)
        });

        if (feesCollectionDetailsArray.length == 0) {
            const obj = {
                studentFeeDetailsId: cell,
                amount: amount,
            };
            feesCollectionDetailsArray.push(obj);
        } else {
            let selectedItem: any;
            feesCollectionDetailsArray.forEach((item: any, index: any) => {
                if (item['studentFeeDetailsId'] == cell) {
                    selectedItem = item
                    selectedItem['amount'] = amount
                }
            });
            if (selectedItem != undefined) {
                selectedItem['amount'] = amount
            } else {
                var obj
                obj = {
                    studentFeeDetailsId: cell,
                    amount: amount,
                };
                feesCollectionDetailsArray.push(obj);
            }
        }

        console.log(feesCollectionDetailsArray);

        totalPayFees()
    }

    function totalPayFees() {
        let totalFeesAmount1 = 0;
        for (let data of feesCollectionDetailsArray) {
            let feeAmount = Number(data.amount)
            totalFeesAmount1 += feeAmount;
        }
        setTotalFeesCollectionAmount(totalFeesAmount1);
        // balanceAmountCal1(fivehunderd_total, twoHundred_total, hundred_total, fifty_total, twenty_total, ten_total, five_total, totalFeesAmount1);

    }

    const multiply500 = (e: any) => {
        const count500 = e.target.value;
        setFivehunderd_total(count500 * 500)
        multiply(count500 * 500, twoHundred_total, hundred_total, fifty_total, twenty_total, ten_total, five_total)
        balanceAmountCal(count500 * 500, twoHundred_total, hundred_total, fifty_total, twenty_total, ten_total, five_total)
    }

    const multiply200 = (e: any) => {
        const count200 = e.target.value;
        setTwoHundred_total(count200 * 200);
        multiply(fivehunderd_total, count200 * 200, hundred_total, fifty_total, twenty_total, ten_total, five_total)
        balanceAmountCal(fivehunderd_total, count200 * 200, hundred_total, fifty_total, twenty_total, ten_total, five_total)

    }

    const multiply100 = (e: any) => {
        const count100 = e.target.value;
        setHundred_total(count100 * 100);
        multiply(fivehunderd_total, twoHundred_total, count100 * 100, fifty_total, twenty_total, ten_total, five_total)
        balanceAmountCal(fivehunderd_total, twoHundred_total, count100 * 100, fifty_total, twenty_total, ten_total, five_total)

    }

    const multiply50 = (e: any) => {
        const count50 = e.target.value;
        setFifty_total(count50 * 50);
        multiply(fivehunderd_total, twoHundred_total, hundred_total, count50 * 50, twenty_total, ten_total, five_total)
        balanceAmountCal(fivehunderd_total, twoHundred_total, hundred_total, count50 * 50, twenty_total, ten_total, five_total)

    }

    const multiply20 = (e: any) => {
        const count20 = e.target.value;
        setTwenty_total(count20 * 20);
        multiply(fivehunderd_total, twoHundred_total, hundred_total, fifty_total, count20 * 20, ten_total, five_total)
        balanceAmountCal(fivehunderd_total, twoHundred_total, hundred_total, fifty_total, count20 * 20, ten_total, five_total)

    }

    const multiply10 = (e: any) => {
        const count10 = e.target.value;
        setTen_total(count10 * 10);
        multiply(fivehunderd_total, twoHundred_total, hundred_total, fifty_total, twenty_total, count10 * 10, five_total)
        balanceAmountCal(fivehunderd_total, twoHundred_total, hundred_total, fifty_total, twenty_total, count10 * 10, five_total)
    }

    const multiply5 = (e: any) => {
        const count5 = e.target.value;
        setFive_total(count5 * 5);
        multiply(fivehunderd_total, twoHundred_total, hundred_total, fifty_total, twenty_total, ten_total, count5 * 5)
        balanceAmountCal(fivehunderd_total, twoHundred_total, hundred_total, fifty_total, twenty_total, ten_total, count5 * 5)
    }

    const multiply = (fivehunderd_total: any, twoHundred_total: any, hundred_total: any, fifty_total: any, twenty_total: any, ten_total: any, five_total: any) => {
        setTotalAmount(Number(fivehunderd_total) + Number(twoHundred_total) + Number(hundred_total) + Number(fifty_total) + Number(twenty_total) + Number(ten_total) + Number(five_total));
    }

    const balanceAmountCal = (fivehunderd_total: any, twoHundred_total: any, hundred_total: any, fifty_total: any, twenty_total: any, ten_total: any, five_total: any) => {
        setBalCashAmount(Number(fivehunderd_total) + Number(twoHundred_total) + Number(hundred_total) + Number(fifty_total) + Number(twenty_total) + Number(ten_total) + Number(five_total) - Number(totalFeesCollectionAmount));
    }

    const balanceAmountCal1 = (fivehunderd_total: any, twoHundred_total: any, hundred_total: any, fifty_total: any, twenty_total: any, ten_total: any, five_total: any, totalFeesAmount: any) => {
        setBalCashAmount(Number(fivehunderd_total) + Number(twoHundred_total) + Number(hundred_total) + Number(fifty_total) + Number(twenty_total) + Number(ten_total) + Number(five_total) - Number(totalFeesAmount));
    }


    function setBulkFeesCollectionDetails() {

        return ({
            receiptDate: payFeesDenominationForm.values.receiptDate != '' ? payFeesDenominationForm.values.receiptDate : null,
            studentFeesCollectionDetails: feesCollectionDetailsArray,
            paymentTypeId: paymentTypeId,
            ledgerRefId: null,
            twoThousand_total: Number(payFeesDenominationForm.values.twoThousand_total) != 0 ? Number(payFeesDenominationForm.values.twoThousand_total) : null,
            twoThousand_count: Number(payFeesDenominationForm.values.twoThousand_count) != 0 ? Number(payFeesDenominationForm.values.twoThousand_count) : null,
            thousand_total: Number(payFeesDenominationForm.values.thousand_total) != 0 ? Number(payFeesDenominationForm.values.thousand_total) : null,
            thousand_count: Number(payFeesDenominationForm.values.thousand_count) != 0 ? Number(payFeesDenominationForm.values.thousand_count) : null,
            fivehunderd_total: Number(fivehunderd_total) != 0 ? Number(fivehunderd_total) : null,
            fivehunderd_count: Number(payFeesDenominationForm.values.fivehunderd_count) != 0 ? Number(payFeesDenominationForm.values.fivehunderd_count) : null,
            twoHundred_total: Number(twoHundred_total) != 0 ? Number(twoHundred_total) : null,
            twoHundred_count: Number(payFeesDenominationForm.values.twoHundred_count) != 0 ? Number(payFeesDenominationForm.values.twoHundred_count) : null,
            hundred_total: Number(hundred_total) != 0 ? Number(hundred_total) : null,
            hundred_count: Number(payFeesDenominationForm.values.hundred_count) != 0 ? Number(payFeesDenominationForm.values.hundred_count) : null,
            fifty_total: Number(fifty_total) != 0 ? Number(fifty_total) : null,
            fifty_count: Number(payFeesDenominationForm.values.fifty_count) != 0 ? Number(payFeesDenominationForm.values.fifty_count) : null,
            twenty_total: Number(twenty_total) != 0 ? Number(twenty_total) : null,
            twenty_count: Number(payFeesDenominationForm.values.twenty_count) != 0 ? Number(payFeesDenominationForm.values.twenty_count) : null,
            ten_total: Number(ten_total) != 0 ? Number(ten_total) : null,
            ten_count: Number(payFeesDenominationForm.values.ten_count) != 0 ? Number(payFeesDenominationForm.values.ten_count) : null,
            five_total: Number(five_total) != 0 ? Number(five_total) : null,
            five_count: Number(payFeesDenominationForm.values.five_count) != 0 ? Number(payFeesDenominationForm.values.five_count) : null,
            totalAmount: Number(totalFeesCollectionAmount),

            /// Cheque Payment ///
            chequeNumber: payFeesDenominationForm.values.chequeNumber != '' ? payFeesDenominationForm.values.chequeNumber : null,
            chequeDate: paymentTypeId == 2 ? payFeesDenominationForm.values.chequeDate : null,
            chequeAmount: Number(payFeesDenominationForm.values.chequeAmount) != 0 ? Number(payFeesDenominationForm.values.chequeAmount) : null,
            chequeBankName: payFeesDenominationForm.values.chequeBankName != '' ? payFeesDenominationForm.values.chequeBankName : null,

            /// Neft Payment ///
            neftRefNumber: payFeesDenominationForm.values.neftRefNumber != '' ? payFeesDenominationForm.values.neftRefNumber : null,
            neftTranDate: paymentTypeId == 3 ? payFeesDenominationForm.values.neftTranDate : null,
            neftAmount: Number(payFeesDenominationForm.values.neftAmount) != 0 ? Number(payFeesDenominationForm.values.neftAmount) : null,
            neftBankName: payFeesDenominationForm.values.neftBankName != '' ? payFeesDenominationForm.values.neftBankName : null,

            /// Card Payment ///
            cardNumber: payFeesDenominationForm.values.cardNumber != '' ? payFeesDenominationForm.values.cardNumber : null,
            cardDate: paymentTypeId == 4 ? payFeesDenominationForm.values.cardDate : null,
            cardAmount: Number(payFeesDenominationForm.values.cardAmount) != 0 ? Number(payFeesDenominationForm.values.cardAmount) : null,
            cardBankName: payFeesDenominationForm.values.cardBankName != '' ? payFeesDenominationForm.values.cardBankName : null,
            narration: payFeesDenominationForm.values.narration != '' ? payFeesDenominationForm.values.narration : null,
            balCashAmount: Number(balCashAmount) != 0 ? Number(balCashAmount) : null,

            courseId: courseId?.value,
            semesterDetailsId: semesterDetailsId?.value,
            sectionDetailsId: sectionDetailsId?.value,
            feeTypeId: feeTypeId?.value,
            courseFeeMasterId: courseFeeMasterId,
            licenseKey: getLicenseKey,
            userAccountId: userAccountId
        })
    }

    function bulkFeeCollectionDetailsSubmit() {
        showLoader(true);
        if (feesCollectionDetailsArray.length > 0) {
            let bulkFeesCollectionDetails = setBulkFeesCollectionDetails();
            addStudentBulkFeeCollection(bulkFeesCollectionDetails,
                (response) => {
                    const data = response.data;
                    if (data.success == true) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "success" });
                        setIsOpen(true);
                        formReset();
                        refreshAfterFeeCollection(data.message);
                    }
                    else if (data.success == false) {
                        showLoader(false);
                        setAlertStatus({ message: data.message, type: "error" });
                        setIsOpen(true);
                    }
                    else {
                        let errorCode = response.data.error[0].error_code;
                        let errorDescription = response.data.error[0].error_description;
                        showLoader(false);
                        setAlertStatus({ message: errorDescription, type: "error" });
                        setIsOpen(true);
                    }
                }
                , (error) => {
                    showLoader(false);
                    setAlertStatus({ message: error, type: "error" });
                    setIsOpen(true);
                })
        } else if (feesCollectionDetailsArray.length == 0) {
            showLoader(false);
            setAlertStatus({ message: 'Please fill all the details!', type: "error" });
            setIsOpen(true);
        }
    }

    function formReset() {
        payFeesDenominationForm.resetForm();
        setPaymentTypeId(0)
        setFivehunderd_total("")
        setTwoHundred_total("")
        setHundred_total("")
        setFifty_total("")
        setTwenty_total("")
        setTen_total("")
        setFive_total("")
        setTotalAmount("")
        setBalCashAmount("")
    }




    return (

        <PageWrapper title="Bulk Fees Collection">

            {dataSuccess ?

                <>
                    <SubHeader>
                        <SubHeaderLeft>
                            <Button color='info' isLink icon='ArrowBack' onClick={() => { setShowPayFees(false); refreshAfterFeeCollection('') }}>
                                Back to List
                            </Button>
                            <SubheaderSeparator />
                            <div>
                                <span>
                                    <strong className='ms-1'>Student List </strong>
                                </span>
                                <span className='border border-success border-2 text-success fw-bold px-3 py-2 rounded ms-1'>
                                    {courseId?.label}
                                </span>
                                <span>
                                    <strong className='ms-3 text-primary'>{semesterDetailsId?.label}</strong>
                                </span>
                            </div>
                        </SubHeaderLeft>
                    </SubHeader>

                    <Page container='fluid'>
                        <Card stretch data-tour='list'>
                            <CardBody>
                                <table className='table table-modern table-hover'>

                                    <thead>
                                        <tr className='table-primary'>

                                            <th scope='col' style={{ width: '5%' }}>

                                                {checkSelectAll ?
                                                    <Checks className="border border-info"
                                                        onChange={(e: any) => { selectAllStudents(e.target.checked) }}
                                                        checked={isCheckAll}
                                                    />
                                                    : <Icon
                                                        size='lg'
                                                        color='success'
                                                        icon='CheckBox'
                                                    />
                                                }
                                            </th>
                                            <th scope='col' style={{ width: '5%' }}>S.No</th>
                                            <th scope='col' style={{ width: '15%' }}>ADMISSION NUM</th>
                                            <th scope='col' style={{ width: '20%' }}>STUDENT NAME</th>
                                            <th scope='col' style={{ width: '10%' }} className="text-center">TOTAL FEE</th>
                                            <th scope='col' style={{ width: '15%' }} className="text-center">TOTAL RECEIVED</th>
                                            <th scope='col' style={{ width: '5%' }} className="text-center">CONCESSION</th>
                                            <th scope='col' style={{ width: '5%' }} className="text-center">BALANCE</th>
                                            <th scope='col' style={{ width: '15%' }} className="text-center">AMOUNT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {studentDetailsData != "" ?
                                            <>
                                                {filteredData.map((i: any) => (
                                                    <tr key={i.studentFeeDetailsId}>
                                                        <td>
                                                            {i.balanceToBePaid > 0 ?
                                                                <Checks
                                                                    className="border border-info"
                                                                    value={i.studentFeeDetailsId}
                                                                    checked={i.isSelect}
                                                                    onChange={(e: any) =>
                                                                        updateStaffDetailsIdValue(
                                                                            e.target.checked,
                                                                            i.studentFeeDetailsId, i.amount
                                                                        )
                                                                    }
                                                                />
                                                                : <Icon
                                                                    size='lg'
                                                                    color='success'
                                                                    icon='CheckBox'
                                                                />
                                                            }
                                                        </td>
                                                        <td>{i.sno}</td>
                                                        <td>{i.admissionNo}</td>
                                                        <td>{i.studentName}</td>
                                                        <td className="text-center text-info">{i.totalFees}</td>
                                                        <td className="text-center text-success">{i.feeReceived}</td>
                                                        <td className="text-center">{i.concession}</td>
                                                        <td className="text-center text-danger">{i.balanceToBePaid}</td>
                                                        {/* <td scope='col'>
                                                            <FormGroup id='uniRegNo'>
                                                                <Input className="w-60" placeholder="" value={i.amount} onInput={(e: any) => updateFeesReceivedValue(i.studentFeeDetailsId, e.target.value)} onKeyDown={(e: any) => onlyAllowNumber(e)} disabled={i.isEditable} />
                                                            </FormGroup>
                                                        </td> */}

                                                        {i.balanceToBePaid == 0 ? <td className='fs-6 fw-bold text-success text-center'>PAID</td> :
                                                            <td>
                                                                <FormGroup id='amount'>
                                                                    <Input className="text-center w-100" placeholder='0' value={i.amount} onInput={(e: any) => updateFeesReceivedValue(i.studentFeeDetailsId, e.target.value)} onKeyDown={(e: any) => onlyAllowNumber(e)} disabled={i.isEditable} />
                                                                    <>
                                                                        {i.amount > 0 && i.balanceToBePaid < i.amount ?

                                                                            <div className="ms-2 mt-2 text-danger">
                                                                                <Icon icon="Report" color="danger" className="mx-1" size="lg" />{''}Amount Not Matching !
                                                                            </div> : (
                                                                                null
                                                                            )}
                                                                    </>
                                                                </FormGroup>

                                                            </td>}
                                                    </tr>
                                                ))}
                                            </>
                                            :
                                            <NoDataMsg columnsCount={10} msg={noDataMsg} />}
                                    </tbody>
                                </table>
                            </CardBody>

                            <CardBody>
                                <div className='row g-4'>
                                    <div className='col-md-3'>
                                        <Card className={`bg-l${darkModeStatus ? 'o25' : '25'
                                            }-warning bg-l${darkModeStatus ? 'o50' : '10'
                                            }-warning-hover transition-base rounded-2 mb-4`}
                                            shadow='sm'>
                                            <CardBody>
                                                <div className='d-flex align-items-center pb-3'>
                                                    <div className='flex-shrink-0'>
                                                        <Icon
                                                            icon='LocalOffer'
                                                            size='4x'
                                                            color='warning'
                                                        />
                                                    </div>
                                                    <div className='flex-grow-1 ms-3'>
                                                        <div className='fw-bold fs-3 text-warning mb-0'>
                                                            ₹ {totalFeesAmount}
                                                        </div>
                                                        <div className='text-muted'>
                                                            <b> Total fees</b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                    <div className='col-md-3'>
                                        <Card className={`bg-l${darkModeStatus ? 'o25' : '25'
                                            }-success bg-l${darkModeStatus ? 'o50' : '10'
                                            }-success-hover transition-base rounded-2 mb-4`}
                                            shadow='sm'>
                                            <CardBody>
                                                <div className='d-flex align-items-center pb-3'>
                                                    <div className='flex-shrink-0'>
                                                        <Icon
                                                            icon='ConfirmationNumber'
                                                            size='4x'
                                                            color='success'
                                                        />
                                                    </div>
                                                    <div className='flex-grow-1 ms-3'>
                                                        <div className='fw-bold fs-3 text-success mb-0'>
                                                            ₹ {totalReceivedFeesAmount}
                                                        </div>
                                                        <div className='text-muted'>
                                                            <b> Paid amount</b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                    <div className='col-md-3'>
                                        <Card className={`bg-l${darkModeStatus ? 'o25' : '25'
                                            }-info bg-l${darkModeStatus ? 'o50' : '10'
                                            }-info-hover transition-base rounded-2 mb-4`}
                                            shadow='sm'>
                                            <CardBody>
                                                <div className='d-flex align-items-center pb-3'>
                                                    <div className='flex-shrink-0'>
                                                        <Icon
                                                            icon='PointOfSale'
                                                            size='4x'
                                                            color='info'
                                                        />
                                                    </div>
                                                    <div className='flex-grow-1 ms-3'>
                                                        <div className='fw-bold fs-3 text-info mb-0'>
                                                            ₹ {totalFeesCollectionAmount}
                                                        </div>
                                                        <div className='text-muted'>
                                                            <b> Fees collected</b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                    <div className='col-md-3'>
                                        <Card className={`bg-l${darkModeStatus ? 'o25' : '25'
                                            }-danger bg-l${darkModeStatus ? 'o50' : '10'
                                            }-danger-hover transition-base rounded-2 mb-4`}
                                            shadow='sm'>
                                            <CardBody>
                                                <div className='d-flex align-items-center pb-3'>
                                                    <div className='flex-shrink-0'>
                                                        <Icon
                                                            icon='Report'
                                                            size='4x'
                                                            color='danger'
                                                        />
                                                    </div>
                                                    <div className='flex-grow-1 ms-3'>
                                                        <div className='fw-bold fs-3 text-danger mb-0'>
                                                            ₹ {totalBalFeesAmount}
                                                        </div>
                                                        <div className='text-muted'>
                                                            <b>Balance to be paid</b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                </div>
                            </CardBody>

                            <CardBody>
                                <div className='row h-100 pb-3'>
                                    <div className='col-lg-4 col-md-6'>
                                        <Card stretch>
                                            <CardHeader>
                                                <CardLabel icon='List'>
                                                    <CardTitle tag='div' className='h5'>
                                                        Payment Denomination
                                                    </CardTitle>
                                                </CardLabel>
                                            </CardHeader>
                                            <CardBody>
                                                <div className='row g-3'>
                                                    <div className='col-12'>
                                                        <Button
                                                            icon='PendingActions'
                                                            color='info'
                                                            className='w-100 p-3'
                                                            isLight={TABS.CASH_PAYMENTS !== activeTab}
                                                            onClick={() => { setActiveTab(TABS.CASH_PAYMENTS); formReset(); setPaymentTypeId(1); }}>
                                                            {TABS.CASH_PAYMENTS}
                                                        </Button>
                                                    </div>
                                                    <div className='col-12'>
                                                        <Button
                                                            icon='LocalPolice'
                                                            color='info'
                                                            className='w-100 p-3'
                                                            isLight={TABS.CHEQUE !== activeTab}
                                                            onClick={() => { setActiveTab(TABS.CHEQUE); formReset(); setPaymentTypeId(2); }}>
                                                            {TABS.CHEQUE}
                                                        </Button>
                                                    </div>
                                                    <div className='col-12'>
                                                        <Button
                                                            icon='Style'
                                                            color='info'
                                                            className='w-100 p-3'
                                                            isLight={TABS.NEFT_UPI !== activeTab}
                                                            onClick={() => { setActiveTab(TABS.NEFT_UPI); formReset(); setPaymentTypeId(3); }}>
                                                            {TABS.NEFT_UPI}
                                                        </Button>
                                                    </div>
                                                    <div className='col-12'>
                                                        <Button
                                                            icon='CreditCard'
                                                            color='info'
                                                            className='w-100 p-3'
                                                            isLight={TABS.CARD_PAYMENT !== activeTab}
                                                            onClick={() => { setActiveTab(TABS.CARD_PAYMENT); formReset(); setPaymentTypeId(4); }}>
                                                            {TABS.CARD_PAYMENT}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </div>
                                    <div className='col-lg-8 col-md-6'>
                                        {TABS.CASH_PAYMENTS === activeTab && (
                                            <Card stretch>
                                                <CardHeader>
                                                    <CardLabel icon='PendingActions'>
                                                        <CardTitle tag='div' className='h5'>
                                                            Cash Denomination
                                                        </CardTitle>
                                                    </CardLabel>
                                                </CardHeader>
                                                <CardBody>
                                                    <div className='row'>
                                                        <div className="d-grid gap-4">
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-4 align-self-center h6">
                                                                </div>
                                                                <div className="col-lg-4 justify-content-center">
                                                                    Count
                                                                </div>

                                                                <div className="col-lg-4 justify-content-center">
                                                                    Amount
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-1 align-self-center h6">
                                                                </div>
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>500 X</p>
                                                                </div>
                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="fivehunderd_count" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.fivehunderd_count} onInput={multiply500} onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                                    </FormGroup>
                                                                </div>

                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="fivehunderd_total" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={fivehunderd_total} disabled />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-1 align-self-center h6">
                                                                </div>
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>200 X</p>
                                                                </div>
                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="twoHundred_total" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.twoHundred_total} onInput={multiply200} onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                                    </FormGroup>
                                                                </div>

                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="twoHundred_total" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={twoHundred_total} disabled />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-1 align-self-center h6">
                                                                </div>
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>100 X</p>
                                                                </div>
                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="hundred_count" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.hundred_count} onInput={multiply100} onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                                    </FormGroup>
                                                                </div>

                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="hundred_total" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={hundred_total} disabled />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-1 align-self-center h6">
                                                                </div>
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>50 X</p>
                                                                </div>
                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="fifty_count" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.fifty_count} onInput={multiply50} onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                                    </FormGroup>
                                                                </div>

                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="fifty_total" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={fifty_total} disabled />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-1 align-self-center h6">
                                                                </div>
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>20 X</p>
                                                                </div>
                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="twenty_count" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.twenty_count} onInput={multiply20} onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                                    </FormGroup>
                                                                </div>

                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="twenty_total" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={twenty_total} disabled />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-1 align-self-center h6">
                                                                </div>
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>10 X</p>
                                                                </div>
                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="ten_count" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.ten_count} onInput={multiply10} onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                                    </FormGroup>
                                                                </div>

                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="ten_total" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={ten_total} disabled />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-1 align-self-center h6">
                                                                </div>
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>5 X</p>
                                                                </div>
                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="five_count" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.five_count} onInput={multiply5} onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                                    </FormGroup>
                                                                </div>

                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="five_total" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={five_total} disabled />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-1 align-self-center h6">
                                                                </div>
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p></p>
                                                                </div>
                                                                <div className="col-lg-4 mt-2 justify-content-center">
                                                                    <p>Total Amount</p>
                                                                </div>
                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="totalAmount" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={totalAmount} disabled />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-1 align-self-center h6">
                                                                </div>
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p></p>
                                                                </div>
                                                                <div className="col-lg-4 mt-2 justify-content-center">
                                                                    <p>Balance Cash Amount</p>
                                                                </div>
                                                                <div className="col-lg-4 justify-content-center">
                                                                    <FormGroup id="balCashAmount" label="">
                                                                        <Input className={balCashAmount < 0 ? 'border border-danger' : ''} type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={balCashAmount} readOnly />
                                                                        <>
                                                                            {balCashAmount < 0 ?
                                                                                <div className='ms-2 text-danger'>
                                                                                    Amount Not Matching !{' '}<Icon icon='Report' color='danger' className='mx-1' size='lg' />
                                                                                </div> : null}
                                                                        </>
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        )}
                                        {TABS.CHEQUE === activeTab && (
                                            <Card stretch>
                                                <CardHeader>
                                                    <CardLabel icon='LocalPolice'>
                                                        <CardTitle tag='div' className='h5'>
                                                            Cheque Details
                                                        </CardTitle>
                                                    </CardLabel>
                                                </CardHeader>
                                                <CardBody>
                                                    <div className='row'>
                                                        <div className="d-grid gap-4">
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>Cheque Number</p>
                                                                </div>
                                                                <div className="col-lg-5 justify-content-center">
                                                                    <FormGroup id="chequeNumber" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.chequeNumber} />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>Amount</p>
                                                                </div>

                                                                <div className="col-lg-5 justify-content-center">
                                                                    <FormGroup id="chequeAmount" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} onBlur={payFeesDenominationForm.handleBlur} value={payFeesDenominationForm.values.chequeAmount} onKeyDown={(e: any) => onlyAllowNumber(e)} />

                                                                    </FormGroup>
                                                                    <>
                                                                        {totalFeesCollectionAmount == Number(payFeesDenominationForm.values.chequeAmount) ? null : (
                                                                            <div className="ms-2 mt-2 text-danger">
                                                                                Amount Not Matching !{' '}
                                                                                <Icon icon="Report" color="danger" className="mx-1" size="lg" />
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                </div>


                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>Cheque Date</p>
                                                                </div>
                                                                <div className="col-lg-5 justify-content-center">
                                                                    <FormGroup id="chequeDate" label="">
                                                                        <Input type="date" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.chequeDate} />
                                                                    </FormGroup>
                                                                </div>

                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>Bank Name</p>
                                                                </div>

                                                                <div className="col-lg-5 justify-content-center">
                                                                    <FormGroup id="chequeBankName" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.chequeBankName} />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        )}
                                        {TABS.NEFT_UPI === activeTab && (
                                            <Card stretch>
                                                <CardHeader>
                                                    <CardLabel icon='Style' iconColor='primary'>
                                                        <CardTitle tag='div' className='h5'>
                                                            NEFT / UPI Details
                                                        </CardTitle>
                                                    </CardLabel>
                                                </CardHeader>
                                                <CardBody>
                                                    <div className='row'>
                                                        <div className="d-grid gap-4">
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>NEFT / UPI Ref Number</p>
                                                                </div>
                                                                <div className="col-lg-5 justify-content-center">
                                                                    <FormGroup id="neftRefNumber" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.neftRefNumber} />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>Amount</p>
                                                                </div>

                                                                <div className="col-lg-5 justify-content-center">
                                                                    <FormGroup id="neftAmount" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.neftAmount} onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                                    </FormGroup>
                                                                    <>
                                                                        {totalFeesCollectionAmount == Number(payFeesDenominationForm.values.neftAmount) ? null : (
                                                                            <div className="ms-2 mt-2 text-danger">
                                                                                Amount Not Matching !{' '}
                                                                                <Icon icon="Report" color="danger" className="mx-1" size="lg" />
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>Transaction Date</p>
                                                                </div>

                                                                <div className="col-lg-5 justify-content-center">
                                                                    <FormGroup id="neftTranDate" label="">
                                                                        <Input type="date" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.neftTranDate} />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>Bank Name</p>
                                                                </div>

                                                                <div className="col-lg-5 justify-content-center">
                                                                    <FormGroup id="neftBankName" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.neftBankName} />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        )}
                                        {TABS.CARD_PAYMENT === activeTab && (
                                            <Card stretch>
                                                <CardHeader>
                                                    <CardLabel icon='CreditCard' iconColor='primary'>
                                                        <CardTitle tag='div' className='h5'>
                                                            Card Details
                                                        </CardTitle>
                                                    </CardLabel>
                                                </CardHeader>
                                                <CardBody>
                                                    <div className='row'>
                                                        <div className="d-grid gap-4">
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>Card Number</p>
                                                                </div>
                                                                <div className="col-lg-5 justify-content-center">
                                                                    <FormGroup id="cardNumber" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.cardNumber} />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>Amount</p>
                                                                </div>

                                                                <div className="col-lg-5 justify-content-center">
                                                                    <FormGroup id="cardAmount" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.cardAmount} onKeyDown={(e: any) => onlyAllowNumber(e)} />
                                                                    </FormGroup>
                                                                    <>
                                                                        {totalFeesCollectionAmount == Number(payFeesDenominationForm.values.cardAmount) ? null : (
                                                                            <div className="ms-2 mt-2 text-danger">
                                                                                Amount Not Matching !{' '}
                                                                                <Icon icon="Report" color="danger" className="mx-1" size="lg" />
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>Transaction Date</p>
                                                                </div>

                                                                <div className="col-lg-5 justify-content-center">
                                                                    <FormGroup id="cardDate" label="">
                                                                        <Input type="date" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.cardDate} />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                <div className="col-lg-3 mt-2 align-self-center h6">
                                                                    <p>Bank Name</p>
                                                                </div>

                                                                <div className="col-lg-5 justify-content-center">
                                                                    <FormGroup id="cardBankName" label="">
                                                                        <Input type="text" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.cardBankName} />
                                                                    </FormGroup>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        )}
                                    </div>
                                </div>
                            </CardBody>
                            <CardBody>
                                <div className='row h-100 pb-3'>
                                    <div className="col-lg-3">
                                        <FormGroup id="receiptDate" label="Receipt Date" isFloating>
                                            <Input type="date" placeholder="" onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.receiptDate} />
                                        </FormGroup>
                                    </div>
                                    <div className="col-lg-5">
                                        <FormGroup id="narration" label="Narration" isFloating>
                                            <Textarea placeholder='Enter Narration' onChange={payFeesDenominationForm.handleChange} value={payFeesDenominationForm.values.narration} />
                                        </FormGroup>
                                    </div>

                                    {paymentTypeId == 1 ?
                                        <div className="col-lg-3 mt-2">
                                            <Button color='info' icon='Save' type="submit" onClick={bulkFeeCollectionDetailsSubmit} isDisable={totalAmount > 0 ? false : true}>Save</Button>
                                        </div>
                                        : null}
                                    {paymentTypeId == 2 ?
                                        <div className="col-lg-3 mt-2">
                                            <Button color='info' icon='Save' type="submit" onClick={bulkFeeCollectionDetailsSubmit} isDisable={Number(totalFeesCollectionAmount == Number(payFeesDenominationForm.values.chequeAmount)) ? false : true}>Save</Button>
                                        </div>
                                        : null}

                                    {paymentTypeId == 3 ?
                                        <div className="col-lg-3 mt-2">
                                            <Button color='info' icon='Save' type="submit" isDisable={Number(totalFeesCollectionAmount == Number(payFeesDenominationForm.values.neftAmount)) ? false : true} onClick={bulkFeeCollectionDetailsSubmit}>Save</Button>
                                        </div>
                                        : null}

                                    {paymentTypeId == 4 ?
                                        <div className="col-lg-3 mt-2">
                                            <Button color='info' icon='Save' type="submit" isDisable={Number(totalFeesCollectionAmount == Number(payFeesDenominationForm.values.cardAmount)) ? false : true} onClick={bulkFeeCollectionDetailsSubmit}>Save</Button>
                                        </div>
                                        : null}
                                </div>
                            </CardBody>
                        </Card>
                    </Page>
                </>
                : <TableLoader />}

            <AlertService setIsOpen={setIsOpen} isOpen={isOpen} alertStatus={alertStatus} />

        </PageWrapper>

    );
};

export default PayBulkFees;